import { render, staticRenderFns } from "./form-latest.vue?vue&type=template&id=2057772e&scoped=true&"
import script from "./form-latest.vue?vue&type=script&lang=js&"
export * from "./form-latest.vue?vue&type=script&lang=js&"
import style0 from "./form-latest.vue?vue&type=style&index=0&id=2057772e&prod&lang=css&"
import style1 from "./form.css?vue&type=style&index=1&id=2057772e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2057772e",
  null
  
)

export default component.exports